import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAoBRZnniQ7K1WMcYFOHte6rNwlfKHX0R8",
  authDomain: "juphy-7d2b9.firebaseapp.com",
  databaseURL: "https://juphy-7d2b9.firebaseio.com",
  projectId: "juphy-7d2b9",
  storageBucket: "juphy-7d2b9.appspot.com",
  messagingSenderId: "958501235262",
  appId: "1:958501235262:web:895e26b18760a5fade3f6f"
});

const db = firebaseApp.firestore();
const storage = firebaseApp.storage()

// Export the database for components to use.
export { db, storage }



// WEBPACK FOOTER //
// ./src/firebase.js